import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

/**
 * Renders a single JSON-LD script tag (schema.org).
 */
function JsonLd({ schema }) {
  if (!schema) return null
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}

JsonLd.propTypes = {
  schema: PropTypes.object,
}

export default JsonLd
